module.exports = __webpack_public_path__ + "img/logo-img.b6611ce2.png";